// @flow
/* eslint-env browser */


/**
 * Generic loadScript promisified function
 *
 * @export
 * @param {string} url
 * @param {boolean} [async=true]
 * @returns
 */
export function loadScript(url: string, async: boolean = true) {
    return new Promise<HTMLScriptElement>((resolve, reject) => {
        const s = document.createElement('script');
        s.async = async;
        s.src = url;
        s.onload = () => resolve(s);
        s.onerror = reject;
        (document.head || document.body || document).appendChild(s);
    });
}
